<template>
  <div>
    <div class="flex flex-wrap-reverse items-center">
      <!-- ADD NEW -->
      <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
        @click="$router.push({name: 'purchaseOrder-new'}).catch (err => {})">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Novo</span>
      </div>
    </div>
    <vue-good-table
      style="width: 100%;"
      styleClass="vgt-table condensed"
      :rows="getPurchaseOrders"
      :columns="columns"
      :pagination-options="paginationOptions"
      :search-options="{enabled: true, placeholder: 'Procurar'}">
      <div slot="emptystate" class="text-center">
        Nenhum resultado encontrado
      </div>

      <template slot="column-filter" slot-scope="{ column, updateFilters }">
        <v-select
          appendToBody
          v-if="column.filterOptions && column.filterOptions.enabled"
          :options="column.filterOptions.items"
          :placeholder="column.filterOptions.placeholder || 'Selecione'"
          @input="(valuesArray) => updateFilters(column, valuesArray)">
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              Nenhuma resultado encontrado para <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
          </template>
        </v-select>
      </template>

      <template slot="table-row" slot-scope="purchaseOrder">
        <span class="font-medium" v-if="purchaseOrder.column.field == 'criadoPara.nome'">
          {{purchaseOrder.row.clientes.fantasia || purchaseOrder.row.criadoPara.nome}}
        </span>
        <span class="font-medium" v-else-if="purchaseOrder.column.field == 'criadoPor.nome'">
          <label v-show="purchaseOrder.row.ordemDeCompra.criadoPor == $store.state.user.idUser">
            Você
          </label>
          <label v-show="purchaseOrder.row.ordemDeCompra.criadoPor != $store.state.user.idUser">
            {{purchaseOrder.row.clientes.fantasia || purchaseOrder.row.criadoPor.nome}}
          </label>
        </span>
        <span class="font-medium" v-else-if="purchaseOrder.column.field == 'modificadoPor.nome'">
          <label v-show="purchaseOrder.row.ordemDeCompra.modificadoPor == $store.state.user.idUser">
            Você
          </label>
          <label v-show="purchaseOrder.row.ordemDeCompra.modificadoPor != $store.state.user.idUser">
            {{purchaseOrder.row.modificadoPor.nome || '-'}}
          </label>
        </span>
        <span class="font-medium" v-else-if="purchaseOrder.column.field == 'ordemDeCompra.jsonProdutos'">
          <vs-dropdown class="cursor-pointer" vs-trigger-click>
            <a class="flex items-center" style="font-weight: 500; font-size: 1rem" href="#">
              <label v-show="productsLength(purchaseOrder.row.ordemDeCompra.jsonProdutos) == 1">{{ productsLength(purchaseOrder.row.ordemDeCompra.jsonProdutos) }} item</label>
              <label v-show="productsLength(purchaseOrder.row.ordemDeCompra.jsonProdutos) > 1">{{ productsLength(purchaseOrder.row.ordemDeCompra.jsonProdutos) }} itens</label>
              <i class="material-icons"> expand_more </i>
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item class="truncate"
                :divider="index != 0"
                v-for="(product, index) in parseProducts(purchaseOrder.row.ordemDeCompra.jsonProdutos)"
                v-bind:key="product.codigo">
                Produto: {{product.descricaoPTBR}}
                <br>
                Quantidade: {{product.quantidade}}
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </span>
        <span class="font-medium" v-else-if="purchaseOrder.column.field == 'anexos'">
          <vs-dropdown class="cursor-pointer" vs-trigger-click>
            <a class="flex items-center" style="font-weight: 500; font-size: 1rem" href="#">
              <label v-show="purchaseOrder.row.anexos.length == 1">{{ purchaseOrder.row.anexos.length }} item</label>
              <label v-show="purchaseOrder.row.anexos.length > 1">{{ purchaseOrder.row.anexos.length }} itens</label>
              <i class="material-icons"> expand_more </i>
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item :divider="index != 0" v-for="(attachment, index) in purchaseOrder.row.anexos" v-bind:key="index">
                Nome: {{attachment.nome}}
                <br>
                Data: {{helpers.dateHelper.formatDateToPTBR(attachment.dataPagamento)}}
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </span>
        <span class="font-medium" v-else-if="purchaseOrder.column.field == 'ações'">
          <div>
            <feather-icon
              icon="EditIcon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
              @click="editPurchaseOrder(purchaseOrder.row.ordemDeCompra.idOrdemDeCompra)" />
            <feather-icon
              icon="UploadIcon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
              @click="attachFilesPurchaseOrder(purchaseOrder.row.ordemDeCompra.idOrdemDeCompra)" />
            <!-- <feather-icon
              icon="Trash2Icon"
              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
              @click="deletePurchaseOrder(purchaseOrder.row.ordemDeCompra.idOrdemDeCompra)" /> -->
          </div>
        </span>
        <span class="font-medium" v-else>
          {{purchaseOrder.formattedRow[purchaseOrder.column.field]}}
        </span>
      </template>
    </vue-good-table>
    <!-- <PurchaseOrderPdf ref="purchaseOrderPdf"></PurchaseOrderPdf> -->
  </div>
</template>
<script>
import helpers from "@/helpers";
// import PurchaseOrderPdf from './PurchaseOrderPdf.vue'
import { baseApiUrl } from "@/global"
import axios from "axios"

export default {
  components: {
    // PurchaseOrderPdf,
  },
  data() {
    return {
      purchaseOrders: [],
      helpers: null,
      columns: [],
      paginationOptions: {
        enabled: true,
        nextLabel: 'Próxima',
        prevLabel: 'Anterior',
        rowsPerPageLabel: 'Resultados por página',
        ofLabel: 'de',
        pageLabel: 'Página',
        allLabel: 'Todos',
        mode: 'pages',
        perPage: 15
      }
    };
  },
  computed: {
    getPurchaseOrders() {
      return this.purchaseOrders
    },
  },
  methods: {
    productsLength(products) {
      products = JSON.parse(products)
      return products.length
    },
    parseProducts(products) {
      return JSON.parse(products)
    },
    sortJsonProdutos(num, numAnterior) {
      num = this.productsLength(num)
      numAnterior = this.productsLength(numAnterior)
      return (num < numAnterior ? -1 : (num > numAnterior ? 1 : 0));
    },
    async loadPurchaseOrders() {
      try {
        this.$vs.loading();
        const response = await axios.get(`${baseApiUrl}/purchaseOrders/`);
        this.purchaseOrders = response.data
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    mountTable() {
      this.columns = [{
          label: 'ID',
          field: 'ordemDeCompra.idOrdemDeCompra',
          type: 'number',
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          label: 'Cliente',
          field: 'criadoPara.nome',
        },
        {
          label: 'Criado Por',
          field: 'criadoPor.nome',
        },
        {
          label: 'Data de Criação',
          field: 'ordemDeCompra.criadoEm',
          formatFn: this.helpers.dateHelper.formatDateTimeToPTBR
        },
        {
          label: 'Modificado Por',
          field: 'modificadoPor.nome'
        },
        {
          label: 'Ultima Modificação',
          field: 'ordemDeCompra.modificadoEm',
          formatFn: this.helpers.dateHelper.formatDateTimeToPTBR
        },
        {
          label: 'Produtos',
          field: 'ordemDeCompra.jsonProdutos',
          sortFn: this.sortJsonProdutos
        },
        {
          label: 'Anexos',
          field: 'anexos',
        },
        {
          label: 'Ações',
          field: 'ações',
          sortable: false
        },
      ]
    },
    editPurchaseOrder(id) {
      this.$router.push(`/ordens-de-compra/editar/${id}`)
    },
    attachFilesPurchaseOrder(id) {
      this.$router.push(`/ordens-de-compra/anexar/${id}`)
    },
    generatePurchaseOrder(id) {
      this.$refs.purchaseOrderPdf.generate(id)
    },
    deletePurchaseOrder(id) {
      console.log('deletar: ', id)
    },
  },
  async created() {
    this.helpers = helpers
    await this.loadPurchaseOrders()
    this.mountTable()
  },
};

</script>
<style lang="scss">
table.vgt-table {
  font-size: 1rem;
}

</style>
